import React, { Component } from "react"
import "gsap"

export default class extends Component {
  componentDidMount() {
    const set = this.el.querySelector("#bambis-mom")
    const shot = this.el.querySelector("#bambis-mom-shot")
    const mom = this.el.querySelector("#bambis-mom-mom")

    this.animation = new TimelineMax({ repeat: -1 })
      .fromTo(set, 1.8, { x: -155, ease: Power1.easeOut }, { x: 150 })
      .to(set, 1.2, { x: -100, ease: Power1.easeOut })
      .to(set, 1, { x: 100, ease: Power1.easeOut })
      .to(set, 1.3, { x: 0, ease: Power1.easeOut })
      .to(shot, 0.1, { opacity: 1, delay: 2 })
      .to(mom, 0, { opacity: 0 })
      .to(shot, 4, { opacity: 0, delay: 0.2 })
      .to(set, 2, { x: -155, ease: Power1.easeOut })
      .to(mom, 1, { opacity: 1, delay: 1 })

    this.animation.paused(!this.props.isActive)
  }

  componentWillReceiveProps(nextProps) {
    this.animation.paused(!nextProps.isActive)
  }

  render() {
    return (
      <svg ref={el => (this.el = el)} viewBox="0 0 600 600">
        <clipPath id="bambis-mom-clip">
          <path d="M600 300c0 165.7-134.3 300-300 300S0 465.7 0 300 134.3 0 300 0s300 134.3 300 300" />
        </clipPath>
        <g clipPath="url(#bambis-mom-clip)">
          <g id="bambis-mom">
            <clipPath id="bambis-mom-clip2">
              <path d="M0 0h600v600H0z" />
            </clipPath>
            <path
              clipPath="url(#bambis-mom-clip2)"
              d="M600 300c0 165.7-134.3 300-300 300S0 465.7 0 300 134.3 0 300 0s300 134.3 300 300"
            />
            <g id="bambis-mom-bg">
              <path
                d="M755.4 298.7c0 32.8-3.9 64.8-11.3 95.4C697.8 586.2 514.7 729.7 296 729.7c-218.5 0-401.3-143.1-447.9-334.8-7.5-30.9-11.5-63.2-11.5-96.3 0-238.1 205.7-431 459.5-431 253.6 0 459.3 193 459.3 431.1z"
                fill="#48CFC2"
              />
              <path
                d="M-216.5 614.6c53.7-128.2 266.2-224 520.2-224 253.6 0 465.9 95.5 520 223.4v.5H-216.5z"
                fill="#A2F2EA"
              />
            </g>
            <g id="bambis-mom-mom">
              <path
                d="M334.1 358c-9-8.2-19.2-11.6-22.9-7.6-3.7 4 .6 13.9 9.6 22.1 3.2 3 6.5 9.5 7 18.2.3 6.8-.9 14-2.2 20-.3 1.2-.8 2.4-1.6 3.4-4.5 5.6-9.9 13.8-14.7 20.1-10.5 13.8-26.6 28.4-24.3 28.5 13.7.7 12.2 1.1 22.7-12.7 9.5-12.5 22.9-21.5 25.3-33 .1-.3.1-.6.2-.9 5.9-17 7.2-52.2.9-58.1z"
                fill="#614E30"
              />
              <path
                d="M352.8 393.6c-1.2.8-2.2 2-3 3.2-.5.8-1.1 1.6-1.6 2.7-4.6 9.3-17 22.8-17 22.8s4.3-18.3 4.3-28.7c0-1.5 0-3 .1-4.3.1-2.3-.6-4.5-2-6.4-3.8-5.1-7.2-11.3-9.8-16.5-1.6-3.2-4.9-5.4-8.5-5.6-12.7-.9-24.4-4-22.2-8.1 5.7-10.7 6.8-7 21.7-7h1.4c5.7-.1 10.7-.6 15-.4 4.8.3 8.7 3.9 9.5 8.6.3 2 .6 4 1 6 .3 1.7.7 3.3 1.2 4.9 3.4 11.3 15.1 25.2 9.9 28.8z"
                fill="#FFCC80"
              />
              <path
                d="M341.7 360.1c-.8-4.3-1.3-8.6-2.2-12.3 2.4 1.6 4.3 4 6 8 .8 2.2-.6 3.5-3.8 4.3z"
                fill="#8D6E63"
              />
              <g fill="#695435">
                <path d="M243.5 262.3c.7-12.6 9.3-41.3 16.3-63.1-.2 3.5-.3 7.6-.3 12.2 0 14.5-8.7 50.8-8.1 52.5 1.1 3.2-3.6 12.9-6.9 24.7-1.7-9.7-3.4-20.7-1.5-24.3.3-.5.4-1.2.5-2zM271 180.2h-5.1c0-.1.1-.2.1-.4.7-2 5.1-.9 5 .4z" />
              </g>
              <path
                d="M430.8 410.1c0-2.4 2.6-18.5-7-23-11.4-5.4-26-14-30-34 0-.1-.1-.2-.1-.3.2-8.7 6.1-16.3 6.1-22.7 0-15.1-6.1-36.5-18.1-40.5-.4-.1-85.7-27.2-94.6-33.3-6.4-4.4-11.4-13.7-12-21.5-1.7-19.1-4.1-54-4-54.7 13.4.1 24.8-.4 25.7-8.7.7-6-2.2-7.1-9.3-11.3-7.3-4.3.5-13.7-3-16-7.1-4.6-19-6.2-23-6-6.4.4-11.2 1.7-15.3 2-6.6.5-10 6.2-10 12.3 0 4.3 2.8 10.6 5.9 16.2.4.7.5 1.5.4 2.3-1.2 7.1.1 22.6-3.3 41.8-2.9 15.9-11 53.2-11.7 55.8-2.2 8.5-4.7 19-4.7 27.2 0 11 3.9 26 10.5 36.5 2 3.2 3.3 6.8 3.7 10.5.1.8.1 1.5.1 2.3 0 8.7-7 43.9-4.8 57.7.3 2.1.3 4.2.1 6.3-.8 8.5-1.1 18.5-2 26-.1 1-.3 2-.4 3-.4 2.4-1.1 4.7-2.1 6.8-5.8 12.6-13.2 35-16.8 40.5-5.1 7.9 5.5 6.3 9.7 6.3s7.3-1.6 7.3-11c0-6.7 4.1-23.6 6.1-34.3.1-.6.3-1.3.4-1.9.8-2.9 1.5-6.1 2.1-9.2 1.7-8.1 4.3-18.4 5.8-26.5.5-2.9 1.6-5.7 3-8.3 7-12.7 15.4-48.5 18.2-65.4.4.3.7.5 1.1.7 1.3.8 2.1 2.3 2.2 3.8.8 21.3 1.6 50.6 3.4 73.4.9 11.1 5 20.4 6.3 28 3 17.3-.3 30.8-.3 42 0 8.1-1.7 18.8-2.4 26.1-1.1 10.4 11 6.2 11.8 5.5 3.8-3.6 1.7-50.2 3.3-89.7 1.1-26.2 5.5-48 8.3-56.3 1.7-5.2 2.9-11 3.7-16.6.3-2.5 2.6-4.3 5.2-4 12.6 1.3 23.1 1 26.5 1 1 0 1.9.3 2.6.8.8.5 1.4 1.2 1.8 2.1 3.6 8.6 10.9 16.5 18.7 21.1.6.3 46.3 33.5 59.1 40.3.9.5 24.8 52 24.8 69.7 0 22.6 4.9 10 11 10s-20-60.1-20-82.8zM259.7 178.7c.5 0 1.3.5 2 .9-1 .1-1.8-.1-2-.9z"
                fill="#614E30"
              />
              <path
                d="M243.5 262.3c.7-12.6 9.3-41.3 16.3-63.1-.2 3.5-.3 7.6-.3 12.2 0 14.5-8.7 50.8-8.1 52.5 1.1 3.2-3.6 12.9-6.9 24.7-1.7-9.7-3.4-20.7-1.5-24.3.3-.5.4-1.2.5-2zM271 180.2h-5.1c0-.1.1-.2.1-.4.7-2 5.1-.9 5 .4z"
                fill="#695435"
              />
              <path
                d="M267.3 347c-2.8-.9-2.8-1.5-5.3-3.2.1.7-9.5 55.7-19.3 59-9.8 3.4 3-63.1 3-71.5v-1.2c.2-3-.2-6-1.6-8.6-7.8-15.6-11.9-35.1-11.9-51.4 0-28.5 22.2-94.8 31.2-95 13.2-.3-4.8 20.5-4.8 49 0 18.6 7.2 66.4 9.9 96.6-.7 7.2-1.4 17.7-1.2 26.3z"
                fill="#FFCC80"
              />
              <g id="left-ear">
                <path
                  d="M244.4 132c0 9.5 1.7 17.2-4.7 17.2s-14.3-8.9-14.3-18.3c0-9.5 1.9-19.8 8-18 7.7 2.2 11 9.6 11 19.1z"
                  fill="#614E30"
                />
                <path
                  d="M240.8 129.6c0 8 2 15.2-1.3 15.2s-11-4.3-11-12.3 1-18 4.3-18 8 7.1 8 15.1z"
                  fill="#FFCC80"
                />
              </g>
              <g id="right-ear">
                <path
                  d="M283.4 126.8c0 8.7-10.2 13.6-13.3 13.3-4-.3-7-.7-3.3-11.3 2.8-8.3 11.2-17.7 14.3-17.7 3.1 0 2.3 7 2.3 15.7z"
                  fill="#614E30"
                />
                <path
                  d="M282.1 126.5c0 6.1-7.9 11.7-10.7 11.7s-1.7-5 1.3-12c2.4-5.6 6.1-12 8.7-11 2.7.9.7 5.2.7 11.3z"
                  fill="#FFCC80"
                />
              </g>
              <path
                d="M264.8 159.1c0 6.2-4.2 6.7-11 6.7s-10.7-5-12.3-11.2c-1.6-6 3.9-12.8 10.7-12.8 6.7 0 12.6 11.2 12.6 17.3zM285.4 145.9c0 3.3.3 10.7-1.9 10.7-2.2 0-5.1-4.2-5.1-7.5s-2.5-8.4-.3-8c2.7.4 7.3 1.5 7.3 4.8z"
                fill="#FFCC80"
              />
              <path
                d="M258.8 154.6c.5 5.5-2.9 6.6-4.1 6.7-5.1.2-6.2.2-9-4.7-2.7-4.7.5-10.5 5.6-10.5 5 0 6.9 2.9 7.5 8.5z"
                fill="#261503"
              />
              <path
                d="M293.8 175.8c0 5.1-20.5 4.4-29.6 4.4s-21.3-15.7-18.8-18.8c3.1-4 14-2.2 24.1-1.7 9 .4 24.3 11 24.3 16.1z"
                fill="#876C44"
              />
              <path
                d="M299.1 168.1c0 4.9-6 10.3-13 10.3s-11-.8-11-5.7 3-11.3 10-11.3c7 .1 14 1.9 14 6.7z"
                fill="#FFCC80"
              />
              <path
                d="M257.6 159c-.9 1.3-5.7 3.4-9 .6-3.9-3.4-2.9-10.2 2.3-10.7 5.4-.6 9.2 6.5 6.7 10.1z"
                fill="#FFF"
              />
              <path d="M257.7 157.9c-1.9 5.5-9.2 3.6-9.9-.7-.5-3 2.3-5.5 5.1-5.5 2.9 0 5.8 3.3 4.8 6.2z" />
              <path
                d="M285.3 151.1c0 3.1-1.2 4.8-2.6 4.8s-2-1.9-2-5 .5-6.1 2-6.1 2.6 3.2 2.6 6.3z"
                fill="#261503"
              />
              <path
                d="M285 151.8c0 2.6-.9 4.1-2 4.1s-2-2.1-2-4.8c0-2.6.9-3.2 2-3.2s2 1.2 2 3.9z"
                fill="#FFF"
              />
              <path d="M285 152c0 3.4-1.1 3.8-2 3.8-.9 0-1.3-.5-1.3-3.8 0-3.4 1.6-3 1.6-3s1.7-.3 1.7 3zM297.2 167c-.4 1.1-3.2 2.8-6.8 2.8-3.6 0-6.7-1.7-7.5-4.5-1-3.4 4.6-2.5 8.1-2.5 3.6 0 7.7.1 6.2 4.2z" />
              <path d="M291.3 175.9h-6.7l.5-1.3 5.7-.2z" fill="#261503" />
            </g>
          </g>
          <ellipse
            id="bambis-mom-shot"
            cx="303"
            cy="299.5"
            fill="#FFF"
            opacity="0"
            rx="328"
            ry="329.5"
          />
          <g fill="none" stroke="#212121" strokeWidth="8">
            <circle cx="300" cy="300" r="271.8" />
            <path d="M0 300h83.4M300 600v-83.4M300 83.4V0M516.6 300H600M300 280v40M280 300h40" />
          </g>
        </g>
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./animations/bambis-mom.js